import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import Grid from '@material-ui/core/Grid'
import { Field } from 'react-final-form'
import {
  withStyles,
  Typography,
  IconButton,
  Tooltip,
  LinearProgress
} from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import VerifiedUser from '@material-ui/icons/VerifiedUser'
import { OnChange } from 'react-final-form-listeners'
import { Select, Snackbar } from 'elentari'
import TextField from '../../../components/TextField'
import DatePicker from '../../../components/DatePicker'
import * as R from 'ramda'
import {
  parseTelefone,
  parsePlaca,
  parseAno,
  parseCpfOrCnpj
} from '../../../utils/Parse'
import {
  validateCpf,
  validateCpfOrCnpj,
  validateAno
} from '../../../utils/Validators'
import UploadField from '../../../components/UploadField'
import veiculosRepository from './VeiculosRepository'
import CustomFileViewer from '../../../components/CustomFileViewer'
import DropzoneField from '../../../components/DropzoneField'
import InputAdornment from '@material-ui/core/InputAdornment'
import RefreshIcon from '@material-ui/icons/Refresh'
import ObservacaoField from '../../../components/ObservacaoField'
import { formatVeiculos } from '../utils/formatVeiculos'

const styles = theme => ({
  root: {
    padding: theme.spacing(6)
  },
  veiculo: {
    marginBottom: theme.spacing(5)
  },
  delete: {
    marginBottom: theme.spacing(1)
  },
  importadoKMM: {
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(2)
  }
})

const validateProprietarioPF = (proprietario, field) => {
  if (proprietario) {
    if (validateCpf(proprietario.cpfcnpj)) {
      if (proprietario[field]) {
        return undefined
      }
      return 'Obrigatório'
    }
  }
}

const validateContratoArrendamento = (veiculos, contratoArrendamento) => {
  if (veiculos) {
    const cpfcnpjs = veiculos
      .map(v => v?.proprietario?.cpfcnpj)
      .filter(c => !!c)
    const mesmoProprietario = cpfcnpjs.every(c => c === cpfcnpjs[0])
    if (!mesmoProprietario && !customTrim(contratoArrendamento)) {
      return 'Obrigatório'
    }
  }
  return undefined
}

const customTrim = str => {
  if (str) {
    return str.toString().trim()
  }
  return ''
}

const validateVeiculo = veiculo => ({
  tipoCarroceria: customTrim(veiculo?.tipoCarroceria)
    ? undefined
    : 'Obrigatório',
  marca: customTrim(veiculo?.marca) ? undefined : 'Obrigatório',
  modelo: customTrim(veiculo?.modelo) ? undefined : 'Obrigatório',
  placa: customTrim(veiculo?.placa) ? undefined : 'Obrigatório',
  municipio: customTrim(veiculo?.municipio) ? undefined : 'Obrigatório',
  uf: customTrim(veiculo?.uf) ? undefined : 'Obrigatório',
  ano: validateAno(veiculo?.ano),
  chassi: customTrim(veiculo?.chassi) ? undefined : 'Obrigatório',
  renavam: customTrim(veiculo?.renavam) ? undefined : 'Obrigatório',
  cor: customTrim(veiculo?.cor) ? undefined : 'Obrigatório',
  crlvImage: customTrim(veiculo?.crlvImage) ? undefined : 'Obrigatório',
  proprietario: {
    nomeRazaoSocial:
      veiculo?.proprietario && customTrim(veiculo?.proprietario.nomeRazaoSocial)
        ? undefined
        : 'Obrigatório',
    cpfcnpj:
      veiculo?.proprietario &&
      validateCpfOrCnpj(veiculo?.proprietario?.cpfcnpj),
    inscricaoEstadual:
      veiculo?.proprietario &&
      customTrim(veiculo?.proprietario.inscricaoEstadual)
        ? undefined
        : 'Obrigatório',
    rntrcTac:
      veiculo?.proprietario && customTrim(veiculo?.proprietario.rntrcTac)
        ? undefined
        : 'Obrigatório',
    rntrcEmissao:
      veiculo?.proprietario && customTrim(veiculo?.proprietario.rntrcEmissao)
        ? undefined
        : 'Obrigatório',
    rntrcValidade:
      veiculo?.proprietario && customTrim(veiculo?.proprietario.rntrcValidade)
        ? undefined
        : 'Obrigatório',
    telefone:
      veiculo?.proprietario && customTrim(veiculo?.proprietario.telefone)
        ? undefined
        : 'Obrigatório',
    pisPasep: validateProprietarioPF(veiculo?.proprietario, 'pisPasep'),
    dataNascimento: validateProprietarioPF(
      veiculo?.proprietario,
      'dataNascimento'
    )
  },
  proprietarioDoc: {
    nomeRazaoSocial:
      veiculo?.proprietario && customTrim(veiculo?.proprietario.nomeRazaoSocial)
        ? undefined
        : 'Obrigatório',
    cpfcnpj:
      veiculo?.proprietario &&
      validateCpfOrCnpj(veiculo?.proprietario?.cpfcnpj),
    inscricaoEstadual:
      veiculo?.proprietario &&
      customTrim(veiculo?.proprietario.inscricaoEstadual)
        ? undefined
        : 'Obrigatório',
    rntrcTac:
      veiculo?.proprietario && customTrim(veiculo?.proprietario.rntrcTac)
        ? undefined
        : 'Obrigatório',
    rntrcEmissao:
      veiculo?.proprietario && customTrim(veiculo?.proprietario.rntrcEmissao)
        ? undefined
        : 'Obrigatório',
    rntrcValidade:
      veiculo?.proprietario && customTrim(veiculo?.proprietario.rntrcValidade)
        ? undefined
        : 'Obrigatório',
    telefone:
      veiculo?.proprietario && customTrim(veiculo?.proprietario.telefone)
        ? undefined
        : 'Obrigatório',
    dataNascimento: validateProprietarioPF(
      veiculo?.proprietario,
      'dataNascimento'
    )
  }
})

export const validateVeiculos = values => {
  const veiculos = []
  veiculos[0] = validateVeiculo(values.veiculos && values.veiculos[0])
  if (values.veiculos && values.veiculos.length) {
    for (let i = 1; i < 4; i++) {
      if (values.veiculos[i] && !R.isEmpty(values.veiculos[i])) {
        veiculos[i] = validateVeiculo(values.veiculos[i])
      }
    }
  }

  const responsavel = {
    nomeResponsavelFrota: customTrim(values.nomeResponsavelFrota)
      ? undefined
      : 'Obrigatório',
    telefoneResponsavelFrota: customTrim(values.telefoneResponsavelFrota)
      ? undefined
      : 'Obrigatório'
  }
  const contratoArrendamentoInput = validateContratoArrendamento(
    values.veiculos,
    values?.contratoArrendamentoInput
  )
  return {
    veiculos,
    ...responsavel,
    contratoArrendamentoInput
  }
}

function VeiculosForm({
  classes,
  values,
  form,
  showError,
  cannotUpdate,
  ...props
}) {
  const [veiculosFormState, setVeiculosFormState] = useState({
    state: '',
    message: ''
  })
  const [fetching, setFetching] = useState(false)
  const [alreadyFetched, setAlreadyFetched] = useState(false)
  const importadoKMM = values?.veiculos && values?.veiculos[0]?.importadoKMM
  const { id } = useParams()
  const isNew = /new/.test(id)

  const handleLimpar = index => {
    const veiculos = values.veiculos
    if (veiculos[index]?.importadoKMM) {
      form.change(`veiculos`, [])
    } else {
      form.change(`veiculos[${index}]`, {})
    }
  }

  const handleCrlvChange = (filePath, index) => {
    form.change(`veiculos[${index}].crlvImage`, filePath)
  }

  const handleContratoChange = filePath => {
    form.change(`contratoArrendamento`, filePath)
  }

  const handleChangePlacaConjunto = async () => {
    const placaFormated =
      values.veiculos && values.veiculos[0] && values.veiculos[0].placa
    if (
      placaFormated &&
      placaFormated.replace(/[^a-zA-Z0-9]/g, '').length === 7 &&
      !alreadyFetched
    ) {
      setAlreadyFetched(true)
      setFetching(true)
      setVeiculosFormState({
        state: 'fetching',
        message: 'Buscando veículos'
      })
      const placa = placaFormated.replace(/[^a-zA-Z0-9]/g, '')
      const response = await veiculosRepository.conjuntoKmm(placa)
      if (response.ok) {
        const veiculos = formatVeiculos(response.data, values)
        form.change(`veiculos`, veiculos)
        setVeiculosFormState({
          state: 'success',
          message:
            'Veículo encontrado com sucesso! Alterações devem ser feitas no KMM.'
        })
      } else {
        const veiculos = values.veiculos
        const clearVeiculos = [
          {
            placa: placaFormated,
            ...(veiculos[0] && veiculos[0].crlvImage
              ? { crlvImage: veiculos[0].crlvImage }
              : null)
          },
          veiculos[1] && veiculos[1].crlvImage
            ? { crlvImage: veiculos[1].crlvImage }
            : null,
          veiculos[2] && veiculos[2].crlvImage
            ? { crlvImage: veiculos[2].crlvImage }
            : null
        ]
        form.change(`veiculos`, clearVeiculos)
        setVeiculosFormState({
          state: 'error',
          message: R.pathOr(
            'Veículo não encontrado!',
            ['data', 'error', 'message'],
            response
          )
        })
      }
      setFetching(false)
    } else {
      setAlreadyFetched(false)
    }
  }

  const renderVeiculoForm = (classes, index) => {
    return (
      <React.Fragment key={index}>
        <Grid container spacing={4} className={classes.veiculo}>
          {/* Veiculos */}
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom>
              {index + 1}° Veículo
              {importadoKMM &&
                R.path(['veiculos', index, 'placa'], values)?.length === 8 && (
                  <Tooltip title="Veículo importado KMM">
                    <VerifiedUser
                      color="disabled"
                      fontSize="small"
                      className={classes.importadoKMM}
                    />
                  </Tooltip>
                )}
              {values.veiculos && values.veiculos[index] && !cannotUpdate && (
                <Tooltip title="Deletar veículo">
                  <IconButton
                    onClick={() => handleLimpar(index)}
                    className={classes.delete}
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              )}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={4}>
              <Grid item xs={12}>
                <Grid container spacing={4} alignItems="center">
                  {isNew ? (
                    <Grid item xs={12} sm={12} lg={4}>
                      <Field
                        accept=".jpg,.jpeg,.png,.pdf"
                        label="CRLV"
                        name={`veiculos[${index}].crlvImage`}
                        component={UploadField}
                        disabled={fetching}
                        onFileChange={filePath =>
                          handleCrlvChange(filePath, index)
                        }
                        showError={showError}
                      />
                    </Grid>
                  ) : (
                    <>
                      {!cannotUpdate && (
                        <Grid item xs={12} sm={12} lg={4}>
                          <Field
                            solicitacaoId={values.id}
                            accept="image/*,.pdf"
                            component={DropzoneField}
                            label="CRLV"
                            name={`veiculos[${index}].crlvImage`}
                            onFileChange={filePath =>
                              handleCrlvChange(filePath, index)
                            }
                          />
                        </Grid>
                      )}
                      <Grid item xs={12} sm={12} lg={4}>
                        <CustomFileViewer
                          newTab
                          label="CRLV"
                          filePath={
                            values.veiculos && values.veiculos[index]?.crlvImage
                          }
                          fileType="pdf"
                        />
                      </Grid>
                    </>
                  )}
                </Grid>
              </Grid>
              <Grid item xs={12} md={4}>
                <Field
                  fullWidth
                  component={TextField}
                  label="Placa"
                  parse={parsePlaca}
                  name={`veiculos[${index}].placa`}
                  disabled={
                    fetching ||
                    (index !== 0 && importadoKMM) ||
                    cannotUpdate ||
                    values.renovado
                  }
                  showError={showError}
                  InputProps={
                    index === 0 && {
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            edge="end"
                            disabled={cannotUpdate}
                            onClick={handleChangePlacaConjunto}
                          >
                            <RefreshIcon />
                          </IconButton>
                        </InputAdornment>
                      )
                    }
                  }
                />
              </Grid>
              <Grid item xs={12} md={8}>
                <Field
                  fullWidth
                  component={TextField}
                  label="Tipo Carroceria"
                  name={`veiculos[${index}].tipoCarroceria`}
                  disabled={fetching || importadoKMM || cannotUpdate}
                  showError={showError}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <Field
                  fullWidth
                  component={TextField}
                  label="Renavam"
                  name={`veiculos[${index}].renavam`}
                  disabled={fetching || importadoKMM || cannotUpdate}
                  showError={showError}
                />
              </Grid>
              <Grid item xs={12} md={8}>
                <Field
                  fullWidth
                  component={TextField}
                  label="Chassi"
                  name={`veiculos[${index}].chassi`}
                  disabled={fetching || importadoKMM || cannotUpdate}
                  showError={showError}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <Field
                  fullWidth
                  component={TextField}
                  label="Marca"
                  name={`veiculos[${index}].marca`}
                  disabled={fetching || importadoKMM || cannotUpdate}
                  showError={showError}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <Field
                  fullWidth
                  component={TextField}
                  label="Modelo"
                  name={`veiculos[${index}].modelo`}
                  disabled={fetching || importadoKMM || cannotUpdate}
                  showError={showError}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <Field
                  fullWidth
                  component={TextField}
                  label="Cor"
                  name={`veiculos[${index}].cor`}
                  disabled={fetching || importadoKMM || cannotUpdate}
                  showError={showError}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <Field
                  fullWidth
                  component={TextField}
                  label="Município"
                  name={`veiculos[${index}].municipio`}
                  disabled={fetching || importadoKMM || cannotUpdate}
                  showError={showError}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <Field
                  fullWidth
                  component={TextField}
                  label="UF"
                  name={`veiculos[${index}].uf`}
                  disabled={fetching || importadoKMM || cannotUpdate}
                  showError={showError}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <Field
                  fullWidth
                  component={TextField}
                  label="Ano"
                  type="number"
                  parse={parseAno}
                  inputProps={{ min: '1950', step: '1' }}
                  name={`veiculos[${index}].ano`}
                  disabled={fetching || importadoKMM || cannotUpdate}
                  showError={showError}
                />
              </Grid>
            </Grid>
          </Grid>
          {/* Proprietário ANTT */}
          <Grid item xs={12}>
            <Typography variant="h6">Proprietário ANTT</Typography>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={4}>
              <Grid item xs={12} md={6}>
                <Field
                  fullWidth
                  component={TextField}
                  label="Nome/Razão Social"
                  name={`veiculos[${index}].proprietario.nomeRazaoSocial`}
                  disabled={fetching || importadoKMM || cannotUpdate}
                  showError={showError}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Field
                  fullWidth
                  component={TextField}
                  label="Apelido/Nome Fantasia"
                  name={`veiculos[${index}].proprietario.apelidoNomeFantasia`}
                  disabled={fetching || importadoKMM || cannotUpdate}
                  showError={showError}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Field
                  fullWidth
                  component={TextField}
                  label="CPF/CNPJ"
                  name={`veiculos[${index}].proprietario.cpfcnpj`}
                  parse={parseCpfOrCnpj}
                  disabled={fetching || importadoKMM || cannotUpdate}
                  showError={showError}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Field
                  fullWidth
                  component={TextField}
                  label="Inscrição Estadual"
                  name={`veiculos[${index}].proprietario.inscricaoEstadual`}
                  disabled={fetching || importadoKMM || cannotUpdate}
                  showError={showError}
                />
              </Grid>
              {validateCpf(
                R.pathOr(
                  null,
                  ['veiculos', index, 'proprietario', 'cpfcnpj'],
                  values
                )
              ) && (
                <>
                  <Grid item xs={12} md={6}>
                    <Field
                      fullWidth
                      component={DatePicker}
                      label="Data nascimento"
                      name={`veiculos[${index}].proprietario.dataNascimento`}
                      disabled={fetching || importadoKMM || cannotUpdate}
                      showError={showError}
                      disableFuture
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Field
                      fullWidth
                      component={TextField}
                      label="PIS/PASEP"
                      name={`veiculos[${index}].proprietario.pisPasep`}
                      disabled={fetching || importadoKMM || cannotUpdate}
                      showError={showError}
                    />
                  </Grid>
                </>
              )}
              <Grid item xs={12} md={4}>
                <Field
                  fullWidth
                  component={TextField}
                  label="RNTRC TAC"
                  name={`veiculos[${index}].proprietario.rntrcTac`}
                  disabled={fetching || importadoKMM || cannotUpdate}
                  showError={showError}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <Field
                  fullWidth
                  component={DatePicker}
                  label="RNTRC Emissão"
                  name={`veiculos[${index}].proprietario.rntrcEmissao`}
                  disabled={fetching || importadoKMM || cannotUpdate}
                  showError={showError}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <Field
                  fullWidth
                  component={DatePicker}
                  label="RNTRC Validade"
                  name={`veiculos[${index}].proprietario.rntrcValidade`}
                  disabled={fetching || importadoKMM || cannotUpdate}
                  showError={showError}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h6">Contato</Typography>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={4}>
              <Grid item xs={12}>
                <Field
                  fullWidth
                  parse={parseTelefone}
                  component={TextField}
                  label="Telefone"
                  name={`veiculos[${index}].proprietario.telefone`}
                  disabled={fetching || importadoKMM || cannotUpdate}
                  showError={showError}
                />
              </Grid>
            </Grid>
          </Grid>
          {/* Proprietário Documento */}
          <Grid item xs={12}>
            <Typography variant="h6">Proprietário Documento</Typography>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={4}>
              <Grid item xs={12} md={6}>
                <Field
                  fullWidth
                  component={TextField}
                  label="Nome/Razão Social"
                  name={`veiculos[${index}].proprietarioDoc.nomeRazaoSocial`}
                  disabled={fetching || importadoKMM || cannotUpdate}
                  showError={showError}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Field
                  fullWidth
                  component={TextField}
                  label="Apelido/Nome Fantasia"
                  name={`veiculos[${index}].proprietarioDoc.apelidoNomeFantasia`}
                  disabled={fetching || importadoKMM || cannotUpdate}
                  showError={showError}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Field
                  fullWidth
                  component={TextField}
                  label="CPF/CNPJ"
                  name={`veiculos[${index}].proprietarioDoc.cpfcnpj`}
                  parse={parseCpfOrCnpj}
                  disabled={fetching || importadoKMM || cannotUpdate}
                  showError={showError}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Field
                  fullWidth
                  component={TextField}
                  label="Inscrição Estadual"
                  name={`veiculos[${index}].proprietarioDoc.inscricaoEstadual`}
                  disabled={fetching || importadoKMM || cannotUpdate}
                  showError={showError}
                />
              </Grid>
              {validateCpf(
                R.pathOr(
                  null,
                  ['veiculos', index, 'proprietarioDoc', 'cpfcnpj'],
                  values
                )
              ) && (
                <>
                  <Grid item xs={12} md={6}>
                    <Field
                      fullWidth
                      component={DatePicker}
                      label="Data nascimento"
                      name={`veiculos[${index}].proprietarioDoc.dataNascimento`}
                      disabled={fetching || importadoKMM || cannotUpdate}
                      showError={showError}
                      disableFuture
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Field
                      fullWidth
                      component={TextField}
                      label="PIS/PASEP"
                      name={`veiculos[${index}].proprietarioDoc.pisPasep`}
                      disabled={fetching || importadoKMM || cannotUpdate}
                      showError={showError}
                    />
                  </Grid>
                </>
              )}
              <Grid item xs={12} md={4}>
                <Field
                  fullWidth
                  component={TextField}
                  label="RNTRC TAC"
                  name={`veiculos[${index}].proprietarioDoc.rntrcTac`}
                  disabled={fetching || importadoKMM || cannotUpdate}
                  showError={showError}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <Field
                  fullWidth
                  component={DatePicker}
                  label="RNTRC Emissão"
                  name={`veiculos[${index}].proprietarioDoc.rntrcEmissao`}
                  disabled={fetching || importadoKMM || cannotUpdate}
                  showError={showError}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <Field
                  fullWidth
                  component={DatePicker}
                  label="RNTRC Validade"
                  name={`veiculos[${index}].proprietarioDoc.rntrcValidade`}
                  disabled={fetching || importadoKMM || cannotUpdate}
                  showError={showError}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Typography variant="h6">Contato</Typography>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={4}>
              <Grid item xs={12}>
                <Field
                  fullWidth
                  parse={parseTelefone}
                  component={TextField}
                  label="Telefone"
                  name={`veiculos[${index}].proprietarioDoc.telefone`}
                  disabled={fetching || importadoKMM || cannotUpdate}
                  showError={showError}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </React.Fragment>
    )
  }

  return (
    <>
      {fetching && <LinearProgress />}
      <div className={classes.root}>
        <Grid container spacing={4} justifyContent="center">
          <Grid item xs={12}>
            {[...Array(4).keys()].map(index =>
              renderVeiculoForm(classes, index)
            )}
            <OnChange name="veiculos[0].placa">
              {handleChangePlacaConjunto}
            </OnChange>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={4} alignItems="center">
              {isNew ? (
                <Grid item xs={12} sm={12} lg={4}>
                  <Field
                    accept=".jpg,.jpeg,.png,.pdf"
                    label="Contrato Arrendamento"
                    name="contratoArrendamentoInput"
                    component={UploadField}
                    disabled={fetching}
                    onFileChange={handleContratoChange}
                    showError={showError}
                  />
                </Grid>
              ) : (
                <>
                  {!cannotUpdate && (
                    <Grid item xs={12} sm={12} lg={4}>
                      <Field
                        solicitacaoId={values.id}
                        accept="image/*,.pdf"
                        component={DropzoneField}
                        label="Contrato Arrendamento"
                        name="contratoArrendamentoInput"
                        onFileChange={handleContratoChange}
                      />
                    </Grid>
                  )}
                  <Grid item xs={12} sm={12} lg={4}>
                    <CustomFileViewer
                      newTab
                      label="Contrato Arrendamento"
                      filePath={values.contratoArrendamento}
                      fileType="pdf"
                    />
                  </Grid>
                </>
              )}
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h6">Rastreador</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Field
              fullWidth
              hideEmpty
              component={Select}
              options={[
                { label: 'Telemonitoramento', value: 'TELEMONITORAMENTO' },
                { label: 'Localizador', value: 'LOCALIZADOR' },
                { label: 'Rastreador', value: 'RASTREADOR' }
              ]}
              label="Tipo de tecnologia"
              name="tecnologia"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Field
              fullWidth
              name="marcaTecnologia"
              label="Marca/Modelo"
              disabled={fetching || cannotUpdate}
              showError={showError}
              component={TextField}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h6">Responsável pela frota</Typography>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={4}>
              <Grid item xs={12} md={6}>
                <Field
                  fullWidth
                  component={TextField}
                  label="Nome"
                  name="nomeResponsavelFrota"
                  disabled={fetching || cannotUpdate}
                  showError={showError}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Field
                  fullWidth
                  parse={parseTelefone}
                  component={TextField}
                  label="Telefone"
                  name="telefoneResponsavelFrota"
                  disabled={fetching || cannotUpdate}
                  showError={showError}
                />
              </Grid>
              <ObservacaoField
                value={values.observacaoContatoProprietario}
                title="Observações Contato Responsável"
                placeholder="Escreva aqui observações sobre as informações do contato com o responsável"
                name="novaObservacaoContatoProprietario"
                disabled={cannotUpdate}
              />
            </Grid>
          </Grid>
          <ObservacaoField
            value={values.observacaoVeiculos}
            title="Observações Veículos"
            placeholder="Escreva aqui observações sobre as informações dos veículos"
            name="novaObservacaoVeiculos"
            disabled={cannotUpdate}
          />
        </Grid>
        <Snackbar
          message={veiculosFormState.message}
          onClose={() =>
            setVeiculosFormState({ ...veiculosFormState, message: '' })
          }
        />
      </div>
    </>
  )
}

export default withStyles(styles)(VeiculosForm)
